// extracted by css-extract-rspack-plugin
export default {"button":"MobileDebugOverlay-module__button___I5LzG","overlay":"MobileDebugOverlay-module__overlay___ehwNe","visible":"MobileDebugOverlay-module__visible___fRgSI"};